import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dataentry',
    templateUrl: './dataentry.component.html',
    styleUrls: ['./dataentry.component.css'],
    standalone: false
})
export class DataentryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
